import React from "react";
import FindCaseStepper from "../../components/crm/FindCaseStepper";
import { ArrowLeft } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
// Human-readable labels for the search summary shown above the results.
const SEARCH_BY_LABELS = {
  all_courts: "All Courts",
  court: "Court No",
  judge: "Judge Name",
  aor_code: "AOR",
  party_name: "Party Name",
};
const LIST_TYPE_LABELS = { daily: "Daily Cause List", other: "Other Lists" };
const MSB_LABELS = { main: "Main", suppli: "Supplementry", both: "Both" };

function SupremeCourtCauseListResults() {
  const location = useLocation();
  const { records, message, searchPayload } = location.state || {};

  if (!records) {
    return (
      <>
                                <div className="relative min-h-screen flex flex-col items-center justify-center">
          <div className="mb-4"><FindCaseStepper current={3} /></div>
          <p className="text-white text-xl">No data available. Please search again.</p>
          <Link to="/portal/fetchfromsupremecourt" className="text-yellow-500 underline mt-4">
            Back to Search
          </Link>
        </div>
      </>
    );
  }

  const p = searchPayload || {};
  const summary = [
    p.listType && `List: ${LIST_TYPE_LABELS[p.listType] || p.listType}`,
    p.searchBy && `Search By: ${SEARCH_BY_LABELS[p.searchBy] || p.searchBy}`,
    p.causelistType && `Type: ${p.causelistType}`,
    p.listingDate && `Date: ${p.listingDate}`,
    p.msb && `${MSB_LABELS[p.msb] || p.msb}`,
  ].filter(Boolean);

  return (
    <>
                        <div className="relative min-h-screen flex flex-col">
          <div className="mb-4"><FindCaseStepper current={3} /></div>
        <main className="px-4 md:px-16 py-8">
          <div className="relative z-10 grid grid-cols-2 items-center p-4">
            <Link to="/portal/fetchfromsupremecourt">
              <div className="flex items-center md:ml-12">
                <ArrowLeft style={{ color: "#334155" }} />
                <h1 className="text-yellow-500 ml-4 font-bold text-2xl">
                  Supreme Court - Cause List Results
                </h1>
              </div>
            </Link>
          </div>

          <div className="flex-grow mt-4 mb-12 flex flex-col items-center relative z-10">
            {summary.length > 0 && (
              <p className="text-slate-600 text-sm mb-4 text-center">
                {summary.join("  •  ")}
              </p>
            )}

            <div className="md:w-3/4 w-11/12 border border-white/20 rounded-2xl bg-white/5 backdrop-blur-sm p-4 md:p-6">
              {records.length === 0 ? (
                <p className="text-slate-600 text-sm text-center">
                  {message || "No records found for the selected criteria."}
                </p>
              ) : (
                <div className="overflow-x-auto">
                  <table className="w-full text-left text-sm text-white border border-white/20 border-collapse">
                    <thead>
                      <tr className="bg-white/10 text-white">
                        <th className="py-3 px-4 font-semibold border border-white/20 w-1/3">Serial Number</th>
                        <th className="py-3 px-4 font-semibold border border-white/20">File</th>
                      </tr>
                    </thead>
                    <tbody>
                      {records.map((r, i) => {
                        const label = r.caseNo || (r.rawCells && r.rawCells[1]) || "View Cause List";
                        return (
                          <tr key={i} className="border border-white/10">
                            <td className="py-3 px-4 border border-white/10">
                              {r.serialNo || (r.rawCells && r.rawCells[0]) || i + 1}
                            </td>
                            <td className="py-3 px-4 border border-white/10">
                              {r.pdfUrl ? (
                                <a
                                  href={r.pdfUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-yellow-500 underline hover:text-yellow-400"
                                >
                                  {label}
                                </a>
                              ) : (
                                <span>{label}</span>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default SupremeCourtCauseListResults;
